import { DefaultDateSettings, DefaultTransportStartTime } from '../constants/default-date-settings';

// Accepteert 'HH:mm:ss' (backend-formaat) en 'HH:mm'; seconden worden genegeerd.
const parseTimeSetting = (value?: string | null): { hours: number, minutes: number } | null => {
  const match = value?.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) {
    return null;
  }

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > 23 || minutes > 59) {
    return null;
  }

  return { hours, minutes };
}

export const getDefaultStartDate = (defaultSetting?: DefaultDateSettings, defaultTransportStartTime?: string | null): number => {
  let date = new Date();

  let addedDays = 0;
  while (addedDays < (defaultSetting ?? 0)) {
    date.setDate(date.getDate() + 1);
    const dayOfWeek = date.getDay();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      addedDays++;
    }
  }

  // Organisatie-instelling; zonder (geldige) waarde valt de starttijd terug op 08:00
  const time = parseTimeSetting(defaultTransportStartTime) ?? parseTimeSetting(DefaultTransportStartTime)!;
  date.setHours(time.hours, time.minutes, 0, 0);

  return date.getTime();
}
